import { portalApi } from '@/axios'

import { Policy } from '@/classes/models'

export default class PolicyRoleService {
  /**
   * Get user policy roles.
   *
   * @param {string} accessToken
   *
   * @return {Promise}
   */
  static get (accessToken) {
    let request = portalApi.get(`${this.endpoint()}/policy-structure`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(response => {
      return response.data
    })

    // Map to Policy
    return request.then(response => {
      return new Policy(response.cashFlowsPolicy)
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Endpoint of API.
   *
   * @return {string}
   */
  static endpoint () {
    return '/user'
  }
}
